// sessionStorage: max 5M
export function getSession(key) {
  return sessionStorage.getItem(key);
}

export function getSessionObject(key) {
  const json = sessionStorage.getItem(key);
  if (json == null || json == undefined) {
    return null;
  }
  try {
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
}

export function setSessionObject(key, value) {
  if (!key) {
    return;
  }
  try {
    removeSession(key);
    let json = null;
    if (value) {
      json = JSON.stringify(value);
    }
    sessionStorage.setItem(key, json);
  } catch (error) {
    // do nothing
  }
}

export function removeSession(key) {
  sessionStorage.removeItem(key);
}

export function clearSession() {
  sessionStorage.clear();
}
